/**
 * i18n initialization for landing page (vanilla JS)
 * Uses i18next for translations
 */
import i18n from '../shared/i18n/config.ts';
import { getCurrentLanguage, addLanguageToPath } from '../shared/utils/urlUtils';

/**
 * Initialize i18n for landing page
 */
export async function initI18n() {
  // Get language from URL or detect
  const lang = getCurrentLanguage();
  
  // Change i18next language
  await i18n.changeLanguage(lang);
  
  // Update page text
  updatePageText();
  
  // Listen for language changes
  i18n.on('languageChanged', () => {
    updatePageText();
  });
}

/**
 * Get translation by key
 */
export function t(key) {
  return i18n.t(key);
}

/**
 * Set language and update URL
 */
export function setLanguage(lang) {
  // Save to localStorage
  localStorage.setItem('gantty_language', lang);
  
  // Change i18next language
  i18n.changeLanguage(lang);
  
  // Update URL with new language
  const currentPath = window.location.pathname;
  const pathWithoutLang = currentPath.replace(/^\/(en|hu|ar|fr|zh-cn|ko|it|es|ja|ru|tr|pt-br)/, '') || '/';
  const newPath = addLanguageToPath(lang, pathWithoutLang);
  
  // Update URL without reload if just language changed
  if (currentPath !== newPath) {
    window.history.pushState({}, '', newPath);
    // Update page text
    updatePageText();
  }
}

/**
 * Get current language
 */
export function getLanguage() {
  return i18n.language;
}

/**
 * Update all text on page with data-i18n attributes
 */
function updatePageText() {
  document.querySelectorAll('[data-i18n]').forEach(element => {
    const key = element.getAttribute('data-i18n');
    const translation = t(key);
    if (translation === key) return;

    const gradientTail = element.getAttribute('data-i18n-gradient-tail');
    if (gradientTail) {
      const words = translation.split(/\s+/);
      const n = parseInt(gradientTail, 10);
      const mainWords = words.slice(0, -n).join(' ');
      const tailWords = words.slice(-n).join(' ');
      element.innerHTML = mainWords + ' <span class="gradient-text">' + tailWords + '</span>';
    } else {
      element.textContent = translation;
    }
  });
  
  // Update placeholder attributes
  document.querySelectorAll('[data-i18n-placeholder]').forEach(element => {
    const key = element.getAttribute('data-i18n-placeholder');
    const translation = t(key);
    if (translation !== key) {
      element.placeholder = translation;
    }
  });
  
  // Update title attributes
  document.querySelectorAll('[data-i18n-title]').forEach(element => {
    const key = element.getAttribute('data-i18n-title');
    const translation = t(key);
    if (translation !== key) {
      element.title = translation;
    }
  });
}

export default { t, setLanguage, getLanguage, initI18n };

